module.exports = __webpack_public_path__ + "img/Ads Reporting.335332d4.svg";